export class Telefono {
    nombre: string;
    descripcion: string;
}



// WEBPACK FOOTER //
// ./src/models/fiesta.model copy.ts